import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { MyIncomingMessage, MyServerResponse } from './getRedirectJob';
import getJobsLocale from './getJobsLocale';
import jobActiveQuery from './queries/jobs/jobActiveQuery.graphql';
import redirectJobSlug from './redirectJobSlug';
import throw404 from './throw404';

const getRedirectJobApply = (
  routeStem: string,
) => (async ({
  req,
  apolloClient,
  query: {
    id,
    slug,
    prefix,
    companySlug,
  },
  res,
}: {
  req?: MyIncomingMessage;
  res?: MyServerResponse;
  apolloClient: ApolloClient<NormalizedCacheObject>;
  query: {
    id: string;
    slug: string;
    prefix?: string;
    companySlug?: string;
  };
}) => {
  if (!req) return {};

  const { locale } = req;
  const { data: { job } } = await apolloClient.query({
    variables: {
      id: Number(id),
      locales: [getJobsLocale(locale)],
    },
    fetchPolicy: 'network-only',
    query: jobActiveQuery,
  });

  if (!job?.active) { return throw404(); }

  return redirectJobSlug(
    job,
    slug,
    id,
    prefix,
    `${routeStem}.${locale}`,
    res,
    companySlug,
  );
});

export default getRedirectJobApply;
